import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class ContentSourceType extends Enum {
  key!: string;
  value!: string;
  icon!: string;

  static TEXT = {
    key: 'text',
    get value(): string {
      return Lang.t('ai.text');
    },
    icon: 'cls-pencil'
  };

  static PDF = {
    key: 'pdf',
    get value(): string {
      return Lang.t('ai.pdf-upload');
    },
    icon: 'cls-upload-bottom'
  };

  static ESTATE_LAW = {
    key: 'estate_law',
    get value(): string {
      return Lang.t('ai.estate-law');
    },
    icon: 'cls-legal-scale-unequal'
  };

  static PLANNER = {
    key: 'planner',
    get value(): string {
      return Lang.t('ai.clara-for-planners');
    },
    icon: 'cls-messages'
  };

  static ADVISOR_QUESTIONNAIRE = {
    key: 'advisor_questionnaire',
    get value(): string {
      return Lang.t('ai.advisor-questionnaire');
    },
    icon: 'cls-single-neutral-actions'
  };

  static getGeneralKnowledgeValues(): ContentSourceType[] {
    return [ContentSourceType.TEXT, ContentSourceType.PDF];
  }

  static getSpecificKnowledgeValues(): ContentSourceType[] {
    return [
      ContentSourceType.ESTATE_LAW,
      ContentSourceType.PLANNER,
      ContentSourceType.ADVISOR_QUESTIONNAIRE
    ];
  }
}
